module.exports = __webpack_public_path__ + "img/ltkeurope-1x.5cab18c.jpg";